export const isDevelopment = () => process.env.NODE_ENV === 'development';
export const isStaging = () => process.env.NODE_ENV === 'staging';
export const isProduction = () => process.env.NODE_ENV === 'production';
export const getReactEnvironment = () => `appenv-${process.env.REACT_APP_ENV}`
export const getEnvironment = () => `env-${process.env.NODE_ENV}`